import { useState } from "react";
import { theme } from "../../../../theme";

const CardTemplate = ({ children, title=null, showToggleBtn = false, isShowMandatoryIcon = false, isBoxShadow = false, headerTextAlign="", spanTitle=null, isCenterTitle=false, isHistory=false }) => {
    const [show, setShow] = useState(showToggleBtn ? false : true);
    const handleToggle = () => setShow((prev) => !prev);

    return (
        <div className={`${isHistory ? '': 'card'}`} style={{boxShadow: isBoxShadow ? "unset" : ""}}>
            {spanTitle && <span className={`badge rounded-pill bg-${theme.main} text-light w-40 mt-n2 mx-auto font-weight-bold`}>{spanTitle}</span>}
            {!isHistory && (
                <div className={`card-header ${headerTextAlign} pb-0 p-3`}>
                    {title && (
                        <>
                            {!isCenterTitle ? (
                                <div className="d-flex justify-content-between align-items-center">
                                    <h6 className="mb-0">
                                        {title}
                                        {isShowMandatoryIcon && (
                                            <i className={`material-icons opacity-10 ms-2 text-danger text-sm`}>
                                                star
                                            </i>
                                        )}
                                    </h6>
                                    {showToggleBtn && (
                                        <button
                                            type="button"
                                            className="btn btn-icon-only btn-rounded btn-outline-secondary mb-0 ms-2 btn-sm d-flex align-items-center justify-content-center"
                                            onClick={handleToggle}
                                        >
                                            <i
                                                className="material-icons text-sm"
                                                style={{
                                                    transition: "transform 0.3s ease",
                                                    transform: show ? "rotate(0deg)" : "rotate(180deg)",
                                                }}
                                            >
                                                keyboard_arrow_down
                                            </i>
                                        </button>
                                    )}
                                </div>
                            ) : (
                                <div className="card-header text-center py-2">
                                    <h6 className="font-weight-bold text-sm">
                                        {title}
                                    </h6>
                                </div>
                            )}
                        </>
                    )}
                </div>
            )}

            <div className={`card-body py-2 ${isHistory && 'px-0 pt-0'}`}>
                {show && children}
            </div>
        </div>
    );
};

export default CardTemplate;